module.exports = __webpack_public_path__ + "static/media/arrowRightIcon.67d40883.svg";